import { render } from "./SegmentosProdView.vue?vue&type=template&id=9a237f8c&scoped=true"
import script from "./SegmentosProdView.vue?vue&type=script&lang=js"
export * from "./SegmentosProdView.vue?vue&type=script&lang=js"

import "./SegmentosProdView.vue?vue&type=style&index=0&id=9a237f8c&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Garantidoras\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a237f8c"]])

export default __exports__